import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/src/layouts/default.vue").then(m => m.default || m)),
  fullscreen: defineAsyncComponent(() => import("/app/src/layouts/fullscreen.vue").then(m => m.default || m))
}